export const SIDE_PADDING = {
  xl: "130px",
  lg: "110px",
  md: "100px",
  sm: "50px",
  xs: "20px",
};
